import DeviceDrawerButton from '../DeviceDrawerButton';
import Subtitle from '../Subtitle';
import styles from './index.module.less';

function Operation() {
  return (
    <div className={`${styles.box} ${styles.device}`}>
      <Subtitle />
      <DeviceDrawerButton />
    </div>
  );
}

export default Operation;
